import { AuthGuard } from '../../shared/services';
import { AssociationsDetailsRoutes } from './associations-details/associations-details.routes';
import { AssociationsListRoutes } from './associations-list/associations-list.routes';
import { AssociationsComponent } from './associations.component';
import { Route } from '@angular/router';
import { AssociationsLandingRoutes } from './association-landing/association-landing.route';

export const AssociationsRoutes: Route[] = [
  {
    path: 'associations',
    component: AssociationsComponent,
    canActivate: [AuthGuard],
    children: [
      ...AssociationsListRoutes,
      ...AssociationsDetailsRoutes,
      ...AssociationsLandingRoutes
    ]
  }
];
